import SessionHelper from "./SessionHelper";

export default class PermissionHelper {
    /**
     * Checks if the currently logged in user has a specific permission for the given route path.
     * @param path The route path, e.g., '/category'
     * @param action The specific action to check ('CanCreate', 'CanEdit', 'CanDelete')
     */
    public static HasPermission(path: string, action: 'CanCreate' | 'CanEdit' | 'CanDelete' | 'CanEditPrice'): boolean {
        const session = SessionHelper.GetSession();
        if (!session) return false;

        // Super Admins have all permissions
        const isSuperAdmin = session.RoleName?.toLowerCase() === 'super admin' || session.RoleName?.toLowerCase() === 'admin';
        if (isSuperAdmin) return true;

        if (!session.Permissions || session.Permissions.length === 0) return false;

        // Match the permission using RoutePath
        const permission = session.Permissions.find(p => p.RoutePath?.toLowerCase() === path.toLowerCase());
        
        if (!permission) return false;

        switch (action) {
            case 'CanCreate': return permission.CanCreate;
            case 'CanEdit': return permission.CanEdit;
            case 'CanDelete': return permission.CanDelete;
            case 'CanEditPrice': return permission.CanEditPrice;
            default: return false;
        }
    }
}
